import React, { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogType,
  DialogFooter,
} from "@fluentui/react/lib/Dialog";
import MaterialStore from "../store/materialstore";
import { Button, DatePicker, notification, Radio, Space } from "antd";

import { observer } from "mobx-react-lite";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import moment from "moment";
import { getPickerDate } from "../../../Utility/modules/datePicker";
const { RangePicker } = DatePicker;
const modalPropsStyles = { main: { maxWidth: 600 } };
const _ = require("underscore");
const materialStoreCtx = createContext(MaterialStore);
const dialogContentProps = {
  type: DialogType.normal,
  title: "Material Consumptions Date Query",
  subText:
    "View Material consumption  for specific  date or date ranges",
};
export const MQuery = observer(() => {
  const materialStore = useContext(materialStoreCtx);
  const [queryType, setQueryType] = useState("specific");
  const [queryDate, setQueryDate] = useState({ startDate: "", endDate: "" });
  const [loading, setLoading] = useState(false);

  return (
    <Dialog
      hidden={!materialStore.showMQeryDialog}
      onDismiss={() => {
        materialStore.showMQeryDialog = false;
      }}
      dialogContentProps={dialogContentProps}
      modalProps={modalPropsStyles}
      minWidth={500}
    >
      <Form layout="vertical">
        <FormItem label="Query By">
          <Radio.Group
            buttonStyle="solid"
            value={queryType}
            onChange={({ target }) => {
              setQueryType(target.value);
            }}
          >
            <Radio.Button value="specific">Specific Date</Radio.Button>
            <Radio.Button value="range">Date Range</Radio.Button>
            <Radio.Button value="inception">
              consumption From Inception
            </Radio.Button>
          </Radio.Group>
        </FormItem>
        {queryType === "specific" ? (
          <FormItem label="Choose consumption date">
            <DatePicker
              style={{ width: "213px" }}
              onChange={(date, dateString) => {
                if (date) {
                  setQueryDate({ ...queryDate, startDate: getPickerDate(date) });
                }
              }}
            />
          </FormItem>
        ) : queryType === "range" ? (
          <FormItem label="Choose consumption date range">
            <RangePicker
              style={{ width: "300px" }}
              onChange={(date, dateString) => {
                if (date) {
                  const [start, end] = date;
                  setQueryDate({
                    startDate: getPickerDate(start),
                    endDate: getPickerDate(end),
                  });
                }
              }}
            />
          </FormItem>
        ) : null}
      </Form>

      <DialogFooter>
        <Space>
          <Button
            type="link"
            onClick={() => {
              materialStore.showMQeryDialog = false;
            }}
          >
            Close
          </Button>
          <Button
            loading={loading}
            type="primary"
            onClick={async () => {
              setLoading(true);
              try {
                let queryCriteria = {};
                materialStore.resultFromQuery = true;
                if (queryType === "specific") {
                  if (!_.isDate(queryDate.startDate)) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select valid consumption date",
                    });
                    return;
                  }
                  queryCriteria = {
                    startDate: moment(queryDate.startDate).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    ),
                    endDate: moment(queryDate.startDate).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    ),
                    fromInception: false,
                    specificDate: true,
                  };

                  materialStore.gridHeaderText = `${
                    materialStore.mainStore.assetContextName
                  } Material Consumption for ${moment(
                    queryCriteria.startDate
                  ).format("ddd DD-MMM-YYYY")} `;
                } else if (queryType === "range") {
                  if (
                    !_.isDate(queryDate.startDate) ||
                    !_.isDate(queryDate.endDate)
                  ) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select valid consumption date",
                    });
                    return;
                  }
                  queryCriteria = {
                    startDate: moment(queryDate.startDate).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    ),
                    endDate: moment(queryDate.endDate).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    ),
                    fromInception: false,
                    specificDate: false,
                  };

                  materialStore.gridHeaderText = `${
                    materialStore.mainStore.assetContextName
                  } Material Consumption from ${moment(
                    queryCriteria.startDate
                  ).format("ddd DD-MMM-YYYY")} to ${moment(
                    queryCriteria.endDate
                  ).format("ddd DD-MMM-YYYY")}`;
                } else if (queryType === "inception") {
                  queryCriteria = {
                    startDate: moment(new Date())
                      .startOf("month")
                      .format("YYYY-MM-DDT00:00:00.000Z"),
                    endDate: moment(new Date())
                      .startOf("month")
                      .format("YYYY-MM-DDT00:00:00.000Z"),
                    fromInception: true,
                    specificDate: false,
                  };

                  materialStore.gridHeaderText = `${materialStore.mainStore.assetContextName}  Material Consumption from Inception`;
                }

                materialStore.queryCriteria = queryCriteria;
                await materialStore.loadConsumptions();
                materialStore.showMQeryDialog = false;
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: error.message,
                });
              } finally {
                setLoading(false);
              }
            }}
          >
            Query
          </Button>
        </Space>
      </DialogFooter>
    </Dialog>
  );
});

